var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 13.125,
    viewBox: "0 0 13.125 13.125",
    width: 13.125,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-7-11.812a6.563 6.563 0 0 0 -6.562 6.562 6.562 6.562 0 0 0 6.562 6.563 6.562 6.562 0 0 0 6.563-6.563 6.563 6.563 0 0 0 -6.563-6.562zm0 3.062a.875.875 0 0 1 .875.875.875.875 0 0 1 -.875.875.875.875 0 0 1 -.875-.875.875.875 0 0 1 .875-.875zm1.094 7h-2.188a.656.656 0 0 1 -.656-.656.656.656 0 0 1 .656-.656h.438v-1.75h-.219a.656.656 0 0 1 -.656-.656.656.656 0 0 1 .656-.656h.875a.656.656 0 0 1 .656.656v2.406h.438a.656.656 0 0 1 .656.656.656.656 0 0 1 -.656.656z",
    fill: "#6b6d84",
    transform: "translate(13.563 11.813)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfo);
export default __webpack_public_path__ + "static/media/ic_info.f334ee0a7309af892201c8eeca3a4798.svg";
export { ForwardRef as ReactComponent };